import { z } from 'zod';
import { PaymentMethodSchema } from '../common/enums.js';
import { IdParamsSchema } from '../common/types.js';
export { PaymentMethodSchema } from '../common/enums.js';
export const PaymentParamsSchema = IdParamsSchema;
export const PaymentExpandQuerySchema = z.object({
    expand: z.string().optional(),
});
export const PaymentStatusSchema = z.enum([
    'pending',
    'succeeded',
    'failed',
    'canceled',
    'refunded',
]);
export const PAYMENT_STATUS = PaymentStatusSchema.enum;
export const PAYMENT_STATUSES = PaymentStatusSchema.options;
export const CreatePaymentSchema = z.object({
    customer_id: z.string().min(1),
    invoice_id: z.string().optional(),
    amount: z.number().min(0.01),
    currency: z.string().length(3),
    payment_method: PaymentMethodSchema,
    payment_date: z.string().optional(),
    description: z.string().max(1000).optional(),
    external_transaction_id: z.string().optional(),
    metadata: z.record(z.unknown()).optional(),
});
export const UpdatePaymentSchema = z.object({
    status: PaymentStatusSchema.optional(),
    payment_method: PaymentMethodSchema.optional(),
    external_transaction_id: z.string().optional(),
    failure_reason: z.string().max(500).optional(),
    notes: z.string().max(1000).optional(),
    metadata: z.record(z.unknown()).optional(),
});
export const ProcessRefundSchema = z.object({
    amount: z.number().min(0.01).optional(),
    reason: z.string().max(500).optional(),
    external_refund_id: z.string().optional(),
    metadata: z.record(z.unknown()).optional(),
});
export const ListPaymentsQuerySchema = z.object({
    customer_id: z.string().optional(),
    invoice_id: z.string().optional(),
    status: PaymentStatusSchema.optional(),
    payment_method: PaymentMethodSchema.optional(),
    date_from: z.string().optional(),
    date_to: z.string().optional(),
    amount_min: z.coerce.number().min(0).optional(),
    amount_max: z.coerce.number().min(0).optional(),
    currency: z.string().length(3).optional(),
    search: z.string().max(100).optional(),
    filter_field: z
        .enum(['customer_name', 'payment_id', 'organization_name'])
        .optional(),
    filter_operator: z
        .enum(['is', 'starts_with', 'ends_with', 'contains'])
        .optional(),
    filter_value: z.string().max(100).optional(),
    page: z.coerce.number().min(1).optional(),
    limit: z.coerce.number().min(1).max(100).optional(),
    sort: z.enum(['created_at', 'processed_at', 'amount', 'status']).optional(),
    order: z.enum(['asc', 'desc']).optional(),
    expand: z.string().optional(),
});
export const PaymentResponseSchema = z.object({
    id: z.string(),
    tenant_id: z.string(),
    organization_id: z.string().nullable(),
    customer_id: z.string().nullable(),
    invoice_id: z.string().nullable(),
    payment_id: z.string(),
    external_payment_id: z.string().nullable(),
    amount: z.number(),
    currency: z.string(),
    refunded_amount: z.number(),
    fees: z.number(),
    net_amount: z.number().nullable(),
    status: PaymentStatusSchema,
    payment_method: PaymentMethodSchema.nullable(),
    notes: z.string().nullable(),
    failure_reason: z.string().nullable(),
    processed_at: z.string().nullable(),
    metadata: z.record(z.unknown()),
    created_at: z.string(),
    updated_at: z.string(),
    customer: z
        .object({
        id: z.string(),
        name: z.string(),
        email: z.string().nullable(),
    })
        .optional(),
    invoice: z
        .object({
        id: z.string(),
        invoice_number: z.string(),
        total_amount: z.number(),
        currency: z.string(),
        status: z.string(),
    })
        .optional(),
});
export const PaymentListResponseSchema = z.object({
    data: z.array(PaymentResponseSchema),
    pagination: z.object({
        page: z.number(),
        limit: z.number(),
        total: z.number(),
        total_pages: z.number(),
        has_next: z.boolean(),
        has_prev: z.boolean(),
    }),
    summary: z
        .object({
        total_amount: z.number(),
        total_refunded: z.number(),
        net_amount: z.number(),
        count_by_status: z.record(z.number()),
    })
        .optional(),
});
export const RefundResponseSchema = z.object({
    id: z.string(),
    payment_id: z.string(),
    amount: z.number(),
    currency: z.string(),
    reason: z.string().nullable(),
    external_refund_id: z.string().nullable(),
    status: z.enum(['pending', 'succeeded', 'failed', 'canceled']),
    processed_at: z.string().nullable(),
    metadata: z.record(z.unknown()),
    created_at: z.string(),
});
//# sourceMappingURL=index.js.map